import toastr from 'toastr'
import access from 'safe-access'
import i18n from "../i18n"



const SHOW_INTERVAL = 3000

export const showNotify = (
  text,
  type = 'success',
  timeOut = SHOW_INTERVAL,
  clearAll = false
) => {
  var opts = {
    closeButton: true,
    debug: false,
    onclick: null,
    showDuration: '300',
    hideDuration: '1000',
    //positionClass: 'toast-top-center',
    timeOut,
  }
  if (clearAll) {
    toastr.remove()
  }

  if (type === 'info') {
    toastr.info(text, 'Información', opts)
  } else if (type === 'success') {
    toastr.success(text, 'Éxito', opts)
  } else if (type === 'warning') {
    toastr.warning(text, 'Advertencia', opts)
  } else if (type === 'error') {
    toastr.error(text, 'Error', opts)
  }
}

export const alertError = (err, text) => {
  let message

  if (!err) {
    message = text || 'Ha ocurrido un error'
  } else if (typeof err === 'string') {
    message = i18n.t(err)
  } else if (access(err, 'response.data.message')) {
    message = access(err, 'response.data.message')
  } else if (access(err, 'message')) {
    message = access(err, 'message')
  } else if (access(err, 'error.message')) {
    message = access(err, 'error.message')
  } else {
    message = text || 'Ha ocurrido un error'
  }

  showNotify(
      message,
      'error'
  )
}
